import css from "./summary.module.css";
import { ClubMembershipState } from "./clubPage.tsx";
import { ClubCard } from "../components/clubCard/clubCard.tsx";
import { WalletCard } from "../components/walletCard/walletCard.tsx";
import { ApprovalBox } from "./approvalBox.tsx";
import { ApprovalRequiredBox } from "./approvalRequiredBox.tsx";
import { AlreadyLinkedBox } from "./alreadyLinkedBox.tsx";
import { PointBalanceCard } from "../components/pointBalanceCard/pointBalanceCard.tsx";

export interface SummaryProps {
  linkExistingClubEnabled: boolean;
  state: ClubMembershipState;
  pointBalance: number;
  exchangeRate: number;
  firstName: string;
  lastName: string;
  appCode?: string;
  cardCode?: string;
  appCodeImage?: string;
  cardCodeImage?: string;
  walletEnabled?: boolean;
  walletQrCodeImage?: string;
  appleWalletEnabled?: boolean;
  googleWalletEnabled?: boolean;
  qrSignedUrlEnabled?: boolean;
}

Summary.tagName = "control-club-summary";

export function Summary(props: SummaryProps) {
  const active = props.state === ClubMembershipState.Active;
  const hasAnyCode = !!(props.cardCode || props.appCode);
  // ApprovalRequired and ApprovalRequested get different boxes on purpose: only in
  // ApprovalRequested has an approval email actually been sent, so only there can it be resent.
  const approvalRequested =
    props.linkExistingClubEnabled && props.state === ClubMembershipState.ApprovalRequested;
  const approvalRequired =
    props.linkExistingClubEnabled && props.state === ClubMembershipState.ApprovalRequired;
  const alreadyLinked =
    props.linkExistingClubEnabled && props.state === ClubMembershipState.AlreadyLinked;
  const approvalFlow = approvalRequested || approvalRequired || alreadyLinked;

  return (
    <div className={css.summary}>
      {active && (
        <PointBalanceCard
          pointBalance={props.pointBalance}
          exchangeRate={props.exchangeRate}
          linkTo="/c/club/history"
        />
      )}
      {!approvalFlow && (
        <ClubCard
          active={active}
          hasAnyCode={hasAnyCode}
          firstName={props.firstName}
          lastName={props.lastName}
          state={props.state}
          appCode={props.appCode}
          appCodeImage={props.appCodeImage}
          cardCode={props.cardCode}
          cardCodeImage={props.cardCodeImage}
        />
      )}

      {active && hasAnyCode && (props.walletEnabled || props.qrSignedUrlEnabled) && (
        <WalletCard
          walletQrCodeImage={props.walletQrCodeImage}
          appleWalletEnabled={props.appleWalletEnabled}
          googleWalletEnabled={props.googleWalletEnabled}
          qrSignedUrlEnabled={props.qrSignedUrlEnabled}
        />
      )}

      {approvalRequested && <ApprovalBox />}
      {approvalRequired && <ApprovalRequiredBox />}
      {alreadyLinked && <AlreadyLinkedBox />}
    </div>
  );
}
